import { TaskPriority, TaskStatus, TaskType } from "@common/types/task";

/** Bank and card accounts the agent copy names. */
export const DEMO_ACCOUNT_NAMES: readonly string[] = [
    "Mercury checking",
    "Chase operating",
    "Amex Platinum",
    "Brex card",
    "SVB savings",
];

export interface DemoTaskTemplate {
    /** `{month}` and `{account}` are filled in per task. */
    title: string;
    type: TaskType;
}

/** Task titles from real close workflows. */
export const DEMO_TASK_TEMPLATES: readonly DemoTaskTemplate[] = [
    { title: "Reconcile {account}", type: TaskType.RECONCILIATION },
    { title: "Review {month} categorization", type: TaskType.TRANSACTIONS },
    { title: "Request missing receipts", type: TaskType.FILE },
    { title: "Accrue {month} payroll", type: TaskType.QUESTION },
    { title: "Review P&L variance", type: TaskType.PROFIT_LOSS },
    { title: "Match {month} transfers", type: TaskType.TRANSACTIONS },
    { title: "Confirm loan balance with lender", type: TaskType.QUESTION },
    { title: "Upload {month} bank statements", type: TaskType.FILE },
    { title: "Record {month} depreciation", type: TaskType.QUESTION },
    { title: "Review uncategorized transactions", type: TaskType.TRANSACTIONS },
    { title: "Send {month} financials to client", type: TaskType.QUESTION },
    { title: "Reconcile {account}", type: TaskType.RECONCILIATION },
    { title: "Collect W-9s for 1099 vendors", type: TaskType.FILE },
    { title: "Review {month} sales tax liability", type: TaskType.QUESTION },
    { title: "Ask client about large deposits", type: TaskType.QUESTION },
    { title: "Review prepaid expenses", type: TaskType.QUESTION },
];

/** Statuses the fake tasks cycle through: mostly open work, a few done. Blocked is off the product surface. */
export const DEMO_TASK_STATUSES: readonly TaskStatus[] = [
    TaskStatus.TODO,
    TaskStatus.IN_PROGRESS,
    TaskStatus.TODO,
    TaskStatus.IN_PROGRESS,
    TaskStatus.TODO,
    TaskStatus.TODO,
    TaskStatus.DONE,
    TaskStatus.IN_PROGRESS,
];

export const DEMO_TASK_PRIORITIES: ReadonlyArray<TaskPriority | null> = [
    TaskPriority.HIGH,
    TaskPriority.MEDIUM,
    null,
    TaskPriority.URGENT,
    TaskPriority.LOW,
    TaskPriority.MEDIUM,
];

/** Fills `{month}` and `{account}` in a demo copy template. */
export const fillDemoCopy = ({
    template,
    month,
    account,
}: {
    template: string;
    month: string;
    account: string;
}) => template.replaceAll("{month}", month).replaceAll("{account}", account);
